export const externalTwin = ({ instances = [], source } = {}) => {
  const value = {
    send_to: instances.map(({ idAnalytics } = {}) => idAnalytics),
    source,
    step: 'TWIN',
  };

  window.gtag('event', 'open_twin', value);

  return value;
};
